import $ from 'jquery';
import template from '../../../html/_includes/components/store-list.hbs';
import StoreListConverter from './StoreListConverter.mjs';
import Swiper, {Pagination} from 'swiper';
import {deviceIsMinMd, gridGutterWidth} from '../utilities/media-queries.mjs';
import {getTranslation, translations} from '../utilities/translations.mjs';

export default class StoreList {
  /**
   * @param {Window.jQuery|HTMLElement|*} $holder jQuery node where to append
   * @param {Object} currentStore
   * @param {Array} furtherStores
   */
  constructor($holder, currentStore, furtherStores) {
    this.swiper = null;

    new StoreListConverter(furtherStores).getStores().then((transformedStores) => {
      const $node = $(template({
        heading: getTranslation(translations.StoreList.HEADING),
        currentStoreName: getCurrentStoreName.call(null, currentStore),
        stores: transformedStores,
        hasStores: transformedStores.length > 0,
      }));

      $holder.html($node);

      deviceIsMinMd.addListener(handleViewportChange.bind(this, deviceIsMinMd, $node))
      handleViewportChange.call(this, deviceIsMinMd, $node);
    });
  }
}

function getCurrentStoreName(currentStore) {
  return `${currentStore.street}, ${currentStore.zip} ${currentStore.city}`;
}

/**
 *
 * @param {MediaQueryList|MediaQueryListEvent} deviceIsMinMd
 * @param {Window.jQuery|HTMLElement|*} $node
 */
function handleViewportChange(deviceIsMinMd, $node) {
  if (deviceIsMinMd.matches) {
    // Destroy slider
    if (swiperIsInitialized(this.swiper) === false) {
      return;
    }

    this.swiper.destroy();

    $node.find('.store-list__slider').removeClass('swiper');
    $node.find('.store-list__list').removeClass('swiper-wrapper');
    $node.find('.store-list-item').removeClass('swiper-slide');
  } else {
    // Init slider
    $node.find('.store-list__slider').addClass('swiper');
    $node.find('.store-list__list').addClass('swiper-wrapper');
    $node.find('.store-list-item').addClass('swiper-slide');

    this.swiper = new Swiper('.swiper', {
      modules: [Pagination],
      slidesPerView: 1.1,
      spaceBetween: gridGutterWidth / 2,
      pagination: {
        el: '.swiper-pagination',
      },
    });
  }
}

function swiperIsInitialized(swiper) {
  return swiper !== null && swiper !== undefined;
}
